import React from 'react';
import {
    MDBCard,
    MDBCardBody,
    MDBCardTitle,
    MDBCardText,
    MDBCardImage,
    MDBCardGroup,
    MDBTooltip,
    MDBBtn
} from "mdb-react-ui-kit";
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { likeTour } from '../redux/features/tourSlice';
import { BsHandThumbsUp, BsHandThumbsUpFill } from "react-icons/bs"

const CardTour = ({ imageFile, description, title, tags, _id, name, likes, }) => {

    const { user } = useSelector((state) => ({ ...state.auth }));
    const userId = user?.result?._id || user?.result?.googleId;

    const dispatch = useDispatch();


    const excerpt = (str) => {
        if (str.length > 45) {
            str = str.substring(0, 45) + " ...";
        }
        return str;
    };


    const Likes = () => {
        if (likes.length > 0) {
            return likes.find((like) => like === userId) ? (
                <>
                    <BsHandThumbsUpFill className='small' />
                    &nbsp;
                    {likes.length > 2 ? (
                        <MDBTooltip
                            tag="a"
                            title={`You and ${likes.length - 1} other people likes`}
                        >
                            {likes.length} Likes
                        </MDBTooltip>
                    ) : (
                        <span className='small'>{`${likes.length} Like${likes.length > 1 ? "s" : ""}`}</span>
                    )}
                </>
            ) : (
                <>
                    <BsHandThumbsUp className='small' />
                    &nbsp;{likes.length} {likes.length === 1 ? "Like" : "Likes"}
                </>
            );
        }
        return (
            <>
                <BsHandThumbsUp className='small' />
                &nbsp;Like
            </>
        );
    };

    const handleLike = () => {
        dispatch(likeTour({ _id }));
    };

    return (
        <MDBCardGroup>
            <MDBCard className=" mt-4 d-sm-flex" style={{ maxWidth: "20rem" }}>
                <MDBCardImage
                    src={imageFile}
                    alt={title}
                    position="top"
                    style={{ maxWidth: "100%", height: "180px" }}
                />
                <div className="top-left">{name}</div>
                <span className="text-start tag-card">
                    {tags.map((tag, index) => (
                        <Link key={index} className='small' to={`/tours/tag/${tag}`}> #{tag}</Link>
                    ))}
                    <MDBBtn
                        style={{ float: "right" }}
                        tag="a"
                        color="none"
                        onClick={!user?.result ? null : handleLike}
                    >
                        {!user?.result ? (
                            <MDBTooltip title="Please login to like tour" tag="a">
                                <Likes />
                            </MDBTooltip>
                        ) : (
                            <Likes />
                        )}
                    </MDBBtn>

                </span>
                <MDBCardBody>
                    <MDBCardTitle style={{ color: '#778899' }} className="text-start">{title}</MDBCardTitle>
                    <MDBCardText className="text-start">
                        {excerpt(description)}
                        <Link to={`/tour/${_id}`}>Read More</Link>
                    </MDBCardText>
                </MDBCardBody>
            </MDBCard>
        </MDBCardGroup>
    );
};

export default CardTour;